/** Shared display helpers for Users / Roles UI. */

export function initialsFromName(first?: string, last?: string, email?: string): string {
  const a = (first || "").trim().charAt(0);
  const b = (last || "").trim().charAt(0);
  if (a || b) return `${a}${b}`.toUpperCase();
  const e = (email || "").trim();
  if (e) return e.slice(0, 2).toUpperCase();
  return "?";
}

export function displayName(first?: string, last?: string, email?: string): string {
  const full = `${first || ""} ${last || ""}`.trim();
  return full || email || "Unknown";
}

export function formatRelativeActive(iso?: string | null): string {
  if (!iso) return "Never";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "Never";
  const diffMs = Date.now() - t;
  if (diffMs < 45_000) return "Now";
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatShortDate(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function statusTone(
  status: string,
): "green" | "blue" | "gray" | "orange" | "red" {
  const s = status.toUpperCase();
  if (s === "ACTIVE") return "green";
  if (s === "INVITED") return "blue";
  if (s === "SUSPENDED") return "gray";
  return "orange";
}

export function statusLabel(status: string): string {
  const s = status.toUpperCase();
  if (s === "ACTIVE") return "Active";
  if (s === "INVITED") return "Invited";
  if (s === "SUSPENDED") return "Suspended";
  return status;
}
